import { render, staticRenderFns } from "./OtherUserGroupMemberRegister.vue?vue&type=template&id=2aa381c0&scoped=true&lang=pug"
import script from "./OtherUserGroupMemberRegister.vue?vue&type=script&lang=ts"
export * from "./OtherUserGroupMemberRegister.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserGroupMemberRegister.vue?vue&type=style&index=0&id=2aa381c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa381c0",
  null
  
)

export default component.exports